module.exports = __webpack_public_path__ + "static/media/elixir-digital-img-1.2d102b87.jpg";